export const CONDITION_TYPE = [
  {
    label: '완전일치',
    value: 'complete_match'
  },
  {
    label: '포함',
    value: 'partial_match'
  }
]